import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import {AuthProvider, RequireAuth, useAuth} from "./pages/Auth/AuthProvider";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";

import Root from "./pages";
import Home from "./pages/Home/index";
import Events from "./pages/Event/Events";
import Event from "./pages/Event";
import MyBanners from "./pages/MyBanners";

// Dashboard components, accessible to only Admins
import Dashboard from "./pages/Dashboard";
import Insights from "./pages/Dashboard/Insights";
import DashboardEvents from "./pages/Dashboard/Events";
import NewEvent from "./pages/Dashboard/NewEvent";
import Profile from "./pages/Dashboard/Profile";
import Users from "./pages/Dashboard/Users";

// Auth screens
import Login from "./pages/Auth/Login";

import NotFound from "./pages/NotFound";

function LoadRoutes() {
  const auth = useAuth();
  const isAdmin = ['SUPER_ADMIN', 'ADMIN'].includes(auth.user?.role);

  if (isAdmin) {
    return (
      <Routes>
        <Route element={<RequireAuth><Dashboard /></RequireAuth>}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard">
            <Route index element={<RequireAuth><Insights /></RequireAuth>} />
            <Route path="events" element={<RequireAuth><DashboardEvents /></RequireAuth>} />
            <Route path="events/new" element={<RequireAuth><NewEvent /></RequireAuth>} />
            <Route path="users" element={<RequireAuth><Users /></RequireAuth>} />
            <Route path="profile" element={<RequireAuth><Profile /></RequireAuth>} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route element={<Root />}>
        <Route path="/" element={<Home />} />
        <Route path=":eventUrl" element={<Event />} />

        {/* redirect /dashboard to / */}
        <Route path="/dashboard" element={<Navigate replace to="/" />} />

        <Route path="events">
          <Route index element={<Events />} />
        </Route>
        <Route path="banners" element={<RequireAuth><MyBanners /></RequireAuth>} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <LoadRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
